import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "@/App";
import { FournisseurSession } from "@/session";
import { AppClient } from "@/client/App";
import { FournisseurSessionClient } from "@/client/session";
import "./index.css";

const racine = document.getElementById("racine");
if (!racine) throw new Error("Élément racine introuvable");

/**
 * Deux mondes, un seul point d'entrée — et jamais les deux à la fois.
 *
 * L'espace client vit sous `/espace-client`. Le partage se fait ici, à la
 * racine, de sorte que le fournisseur de session INTERNE n'est jamais monté
 * dans l'arbre du client, ni l'inverse : un écran client ne peut pas lire une
 * identité interne, même par accident (ADR-0012).
 *
 * Le routeur du LOT 1 n'enveloppe QUE l'application interne : l'espace client a
 * deux écrans et aucune adresse profonde à partager, et lui en donner un
 * ouvrirait une porte entre les deux arbres — précisément ce que l'ADR-0012
 * interdit.
 */
const estEspaceClient = window.location.pathname.startsWith("/espace-client");

createRoot(racine).render(
  <StrictMode>
    {estEspaceClient ? (
      <FournisseurSessionClient>
        <AppClient />
      </FournisseurSessionClient>
    ) : (
      <BrowserRouter>
        <FournisseurSession>
          <App />
        </FournisseurSession>
      </BrowserRouter>
    )}
  </StrictMode>,
);
